import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivate
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { State } from '../../store/reducers';

@Injectable()
export class AccommodationGuard implements CanActivate {
  constructor(private store: Store<State>) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const canView$ = this.store.select(
      appState => appState.payment.paidForAccommodation
    );
    return canView$;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/confirmation/services/accommodation.guard.ts